import React, { Fragment, memo } from 'react';
import T from 'prop-types';
import { StyleSheet } from 'react-native';
import { Text, TouchableItem, View, Image } from '../../../../ReusableComponents';
import { colors, dimensions } from '../../../../../styles';

const s = StyleSheet.create({
  contentContainer: {},
  itemImage: {
    height: 44,
    width: 44,
    backgroundColor: colors.grayLighter,
    borderRadius: 3,
    marginRight: dimensions.medium,
  },
  button: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: dimensions.halfMedium,
    backgroundColor: colors.white,
    paddingHorizontal: dimensions.medium,
  },
});

const AdditionalItem = memo(({ image, title, onPress }) => {
  return (
    <TouchableItem style={s.button} onPress={onPress}>
      <Fragment>
        <Image
          source={{ uri: image || 'city_placeholder' }}
          style={s.itemImage}
          resizeMode="cover"
        />
        <View>
          <Text medium numberOfLines={1} ellipsizeMode="tail">
            {title}
          </Text>
        </View>
      </Fragment>
    </TouchableItem>
  );
});

AdditionalItem.propTypes = {
  onPress: T.func,
  title: T.string,
  image: T.string,
};

export default AdditionalItem;
